import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'

import { greyMultibrandPalette } from '@masfront/common-b2c/src/modules/ui/theme/colors'

type AlertVariant = 'big' | 'small' | 'chip' | 'rounded'

interface B2CAlertProps {
  className?: string
  alertText?: string
  variant?: AlertVariant
  icon?: React.ReactNode
}

interface B2CAlertStyles {
  variant?: AlertVariant
}

const useStyles = makeStyles(() => {
  return {
    root: {
      alignSelf: 'center',
    },
    alert: {
      borderRadius: ({ variant }: B2CAlertStyles) => (variant === 'rounded' ? '50%' : '2px'),
      boxShadow:
        '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
      minWidth: ({ variant }: B2CAlertStyles) => {
        switch (variant) {
          case 'small':
            return '68px'
          case 'chip':
            return '18px'
          case 'rounded':
            return '8px'
          case 'big':
          default:
            return '86px'
        }
      },
      height: ({ variant }: B2CAlertStyles) => {
        switch (variant) {
          case 'small':
          case 'chip':
            return '18px'
          case 'rounded':
            return '8px'
          case 'big':
          default:
            return '24px'
        }
      },
      '& .MuiAlert-message': {
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        margin: '0 auto',
        color: greyMultibrandPalette[900],
      },
      '& .MuiAlert-icon': {
        padding: 0,
        order: 1,
        margin: 0,
      },
    },
  }
})

const B2CAlert: React.FC<B2CAlertProps> = ({ className, alertText, variant = 'big', icon }) => {
  const classes = useStyles({ variant })
  const typographyVariant = variant === 'small' ? 'overline' : 'h6'

  return (
    <Box className={classes.root}>
      <Alert className={`${className} ${classes.alert}`} icon={icon || false} variant="filled">
        {variant !== 'rounded' && alertText && (
          <Typography variant={typographyVariant}>{alertText}</Typography>
        )}
      </Alert>
    </Box>
  )
}

export default B2CAlert
